"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ticketTypeEnum = exports.supperStatusEnum = exports.settlementMethodEnum = exports.priceEnum = exports.platformTypeEnum = exports.platformStatusEnum = exports.operationTypeEnum = exports.merchantEnum = exports.cooperationStatusEnum = void 0;
//合作状态
var cooperationStatusEnum = exports.cooperationStatusEnum = [{
  label: '待联系',
  value: 1
}, {
  label: '初次联系无回复',
  value: 2
}, {
  label: '资料收集',
  value: 3
}, {
  label: '商务洽谈',
  value: 4
}, {
  label: '签订合同',
  value: 5
}, {
  label: '合同终止',
  value: 6
}];
var ticketTypeEnum = exports.ticketTypeEnum = [{
  label: '无票',
  value: 1
}, {
  label: '普票',
  value: 2
}, {
  label: '专票',
  value: 3
}, {
  label: '混合票种',
  value: 4
}];
var settlementMethodEnum = exports.settlementMethodEnum = [{
  label: '提供账期',
  value: 1
}, {
  label: '现货现款',
  value: 2
}, {
  label: '部分预付',
  value: 3
}, {
  label: '预存代发',
  value: 4
}];
//操作类型
var operationTypeEnum = exports.operationTypeEnum = [{
  label: '充值',
  value: 1
}, {
  label: '扣费',
  value: 2
}];
//价格形式
var priceEnum = exports.priceEnum = [{
  label: '价格',
  value: 1
}, {
  label: '折扣',
  value: 2
}];
//商户
var merchantEnum = exports.merchantEnum = [{
  label: '自营',
  value: 1
}, {
  label: '锦诚',
  value: 2
}];
//平台状态
var platformStatusEnum = exports.platformStatusEnum = [{
  label: '上架',
  value: 1
}, {
  label: '下架',
  value: 0
}];
//商家状态
var supperStatusEnum = exports.supperStatusEnum = [{
  label: '上架',
  value: 1
}, {
  label: '下架',
  value: 0
}];

//运营方式
var platformTypeEnum = exports.platformTypeEnum = [{
  label: '自营',
  value: 1
}, {
  label: '代运营',
  value: 2
}];